/**
 * Phase 6 · the deal screens' shared strings: navigation, titles, the vocabularies every deal
 * screen names, the list and the new-deal dialog. Spread into `HU` and `EN` in `../catalogue.ts`.
 * The other files in this folder hold one area each.
 */
export const HU = {
  /* ── navigation and titles ── */
  'nav.deals': 'Dealek',
  'nav.dealsSection': 'Dealek',
  'nav.dealsEmpty': 'Csillagozz meg egy dealt, és itt marad kéznél.',
  'nav.newDeal': 'Új deal',
  'nav.allDeals': 'Minden deal',
  'title.deals': 'Dealek',
  'title.deal': 'Deal',
  'title.settingsDeals': 'Deal menedzsment · Beállítások',
  'settings.nav.deals': 'Deal menedzsment',

  /* ── the vocabularies ── */
  'deal.category.open': 'Nyitott',
  'deal.category.won': 'Megnyert',
  'deal.category.lost': 'Elvesztett',
  'deal.forecast.commit': 'Bekötött',
  'deal.forecast.best_case': 'Legjobb eset',
  'deal.forecast.pipeline': 'Pipeline',
  'deal.forecast.omitted': 'Kizárva',
  'deal.source.inbound': 'Beérkező megkeresés',
  'deal.source.referral': 'Ajánlás',
  'deal.source.outbound': 'Saját megkeresés',
  'deal.source.existing': 'Meglévő ügyfél',
  'deal.source.tender': 'Pályázat / tender',
  'deal.source.partner': 'Partner',
  'deal.seniority.junior': 'Junior',
  'deal.seniority.medior': 'Medior',
  'deal.seniority.senior': 'Senior',
  'deal.revenueMode.one_off': 'Egyszeri',
  'deal.revenueMode.recurring': 'Ismétlődő',
  'deal.revenueMode.milestones': 'Mérföldkövek szerint',
  'deal.revenueMode.manual': 'Kézi',
  'deal.lineType.fixed': 'Fix',
  'deal.lineType.tm': 'Idő és anyag',
  'deal.lineType.license': 'Licenc',
  'deal.lineType.option': 'Opció',
  'deal.lineStatus.draft': 'Tervezet',
  'deal.lineStatus.open': 'Nyitott',
  'deal.lineStatus.closed': 'Lezárt',
  'deal.rateUnit.hour': 'óra',
  'deal.rateUnit.day': 'nap',
  'deal.rateUnit.month': 'hónap',
  'deal.eventKind.note': 'Jegyzet',
  'deal.eventKind.task': 'Feladat',
  'deal.eventKind.meeting': 'Találkozó',
  'deal.eventKind.call': 'Hívás',
  'deal.eventKind.email': 'E-mail',
  'deal.eventKind.system': 'Rendszer',

  /* ── the modes ── */
  'deals.mode.list': 'Lista',
  'deals.mode.kanban': 'Pipeline',
  'deals.mode.forecast': 'Forecast',
  'deals.mode.demand': 'Erőforrás-igény',

  /* ── the list ── */
  'deals.view.open': 'Nyitott',
  'deals.view.all': 'Minden deal',
  'deals.view.mine': 'Az enyéim',
  'deals.view.rot': 'Rothadó',
  'deals.view.nonext': 'Következő lépés nélkül',
  'deals.view.quarter': 'Ebben a negyedévben zár',
  'deals.view.slip': 'Csúszott',
  'deals.view.won': 'Megnyert',
  'deals.view.lost': 'Elvesztett',
  'deals.view.conv': 'Konvertálva',
  'deals.column.identifier': 'Deal',
  'deals.column.name': 'Név',
  'deals.column.client': 'Cég',
  'deals.column.status': 'Státusz',
  'deals.column.probability': 'Esély',
  'deals.column.forecast': 'Forecast',
  'deals.column.value': 'Érték',
  'deals.column.weighted': 'Súlyozott',
  'deals.column.hours': 'Terv óra',
  'deals.column.owner': 'Tulajdonos',
  'deals.column.close': 'Várható zárás',
  'deals.column.next': 'Következő lépés',
  'deals.column.stage': 'Státuszban',
  'deals.column.activity': 'Utolsó aktivitás',
  'deals.filter.status': 'Státusz',
  'deals.filter.owner': 'Tulajdonos',
  'deals.filter.client': 'Cég',
  'deals.filter.forecast': 'Forecast kategória',
  'deals.search': 'Keresés dealre, cégre…',
  'deals.days': '{count} nap',
  'deals.next.none': 'nincs megadva',
  'deals.next.late': 'A határidő elmúlt.',
  'deals.rotting': 'Rothadó deal: {count} napja ugyanabban a státuszban.',
  'deals.footer': '{count} deal · Σ {value} · súlyozott {weighted} · bekötött {committed}',
  'deals.action.create': 'Új deal',
  'deals.action.open': 'Megnyitás',
  'deals.action.favourite': 'Kedvencekhez',
  'deals.action.unfavourite': 'Eltávolítás a kedvencek közül',
  'deals.action.won': 'Megnyert',
  'deals.action.lost': 'Elvesztett',
  'deals.action.reopen': 'Újranyitás',
  'deals.action.generate': 'Generálás',
  'deals.action.delete': 'Deal törlése',
  'deals.action.omit': 'Forecast → kizárva',
  'deals.empty.title': 'Még nincs deal',
  'deals.empty.body':
    'Egy deal az első megkereséstől a szerződésig követi az üzletet. Kezdd egy névvel és egy céggel.',
  'deals.empty.filtered': 'Ebben a nézetben nincs deal.',
  'deals.toast.created': 'Deal létrehozva',
  'deals.toast.deleted': 'Deal törölve',
  'deals.toast.omitted': '{count} deal kizárva a forecastból',
  'deals.error.value': 'Adj meg egy nem negatív összeget.',

  /* ── the new-deal dialog ── */
  'deals.new.title': 'Új deal',
  'deals.new.hint':
    'Kötelező a név, a cég, a tulajdonos és a státusz. Minden más pótolható később — egy beérkező megkeresés is érvényes deal.',
  'deals.new.name': 'Név',
  'deals.new.namePlaceholder': 'Pl. Rossmann — készletmodul 2. ütem',
  'deals.new.client': 'Cég',
  'deals.new.contact': 'Kapcsolattartó',
  'deals.new.owner': 'Tulajdonos',
  'deals.new.status': 'Státusz',
  'deals.new.value': 'Indikatív érték',
  'deals.new.close': 'Várható zárás',
  'deals.new.source': 'Forrás',
  'deals.new.none': 'Nincs megadva',
  'deals.new.submit': 'Deal létrehozása',
  'deals.new.pickClient': 'Válassz céget',
  'contacts.action.create': 'Új kapcsolattartó',

  /* ── DM-5 · the resource planner's tentative deal bookings ── */
  'resource.filter.tentative': 'Deal-foglalások',
  'resource.filter.tentativeHidden': 'Rejtve',
  'resource.filter.tentativeShown': 'Mutatva',
  'resource.tentative.label': 'Tentatív',
  'resource.tentative.hint':
    'Egy nyitott deal tervezett órái erre a személyre. Nem foglal kapacitást, és a kihasználtságba sem számít bele.',

  /* ── D10 · the Agent screen's labels for the deal tools ── */
  'agent.tool.deals_search.running': 'Dealek keresése…',
  'agent.tool.deals_search.done': '{count} deal',
  'agent.tool.deals_get.running': 'Deal megnyitása…',
  'agent.tool.deals_get.done': 'Deal elolvasva',
  'agent.tool.deals_pipeline.running': 'Pipeline áttekintése…',
  'agent.tool.deals_pipeline.done': 'Pipeline áttekintve',
  'agent.tool.deals_forecast.running': 'Forecast számolása…',
  'agent.tool.deals_forecast.done': 'Forecast elkészült',
  'agent.tool.deals_demand.running': 'Erőforrás-igény számolása…',
  'agent.tool.deals_demand.done': 'Erőforrás-igény elkészült',
  'agent.tool.deal_settings_get.running': 'Deal beállítások olvasása…',
  'agent.tool.deal_settings_get.done': 'Deal beállítások elolvasva',
  'agent.tool.deals_create.running': 'Új deal előkészítése…',
  'agent.tool.deals_create.done': 'Új deal jóváhagyásra vár',
  'agent.tool.deals_update.running': 'Deal módosítás előkészítése…',
  'agent.tool.deals_update.done': 'Módosítás jóváhagyásra vár',
  'agent.tool.deals_set_status.running': 'Státuszváltás előkészítése…',
  'agent.tool.deals_set_status.done': 'Státuszváltás jóváhagyásra vár',
  'agent.tool.deals_mark_won.running': 'Megnyerés előkészítése…',
  'agent.tool.deals_mark_won.done': 'Megnyerés jóváhagyásra vár',
  'agent.tool.deals_mark_lost.running': 'Elvesztés előkészítése…',
  'agent.tool.deals_mark_lost.done': 'Elvesztés jóváhagyásra vár',
  'agent.tool.deals_set_next_step.running': 'Következő lépés előkészítése…',
  'agent.tool.deals_set_next_step.done': 'Következő lépés jóváhagyásra vár',
  'agent.tool.deals_log_activity.running': 'Aktivitás előkészítése…',
  'agent.tool.deals_log_activity.done': 'Aktivitás jóváhagyásra vár',
  'agent.tool.deals_reopen.running': 'Újranyitás előkészítése…',
  'agent.tool.deals_reopen.done': 'Újranyitás jóváhagyásra vár',
  'agent.tool.deals_complete_next_step.running': 'Lépés lezárásának előkészítése…',
  'agent.tool.deals_complete_next_step.done': 'Lépés lezárása jóváhagyásra vár',
  'agent.tool.deals_update_activity.running': 'Aktivitás módosításának előkészítése…',
  'agent.tool.deals_update_activity.done': 'Módosítás jóváhagyásra vár',
  'agent.tool.deals_delete_activity.running': 'Aktivitás törlésének előkészítése…',
  'agent.tool.deals_delete_activity.done': 'Törlés jóváhagyásra vár',
  'agent.tool.deals_delete.running': 'Deal törlésének előkészítése…',
  'agent.tool.deals_delete.done': 'Törlés jóváhagyásra vár',
  'agent.tool.deal_scenarios_search.running': 'Szcenáriók olvasása…',
  'agent.tool.deal_scenarios_search.done': '{count} szcenárió',
  'agent.tool.deal_scenarios_get.running': 'Szcenárió megnyitása…',
  'agent.tool.deal_scenarios_get.done': 'Szcenárió elolvasva',
  'agent.tool.deal_scenarios_mark_winner.running': 'Nyertes szcenárió előkészítése…',
  'agent.tool.deal_scenarios_mark_winner.done': 'Nyertes szcenárió jóváhagyásra vár',

  /* ── the record's frame ── */
  'deal.tab.overview': 'Áttekintés',
  'deal.tab.scenario': 'Scenario',
  'deal.tab.plan': 'Terv',
  'deal.tab.resource': 'Erőforrás',
  'deal.back': 'Vissza a dealekhez',
  'deal.stage.days': '{count} nap',
  'deal.copy.label': 'Másolás',
  'deal.copy.identifier': 'Azonosító másolása',
  'deal.copy.link': 'Link másolása',
  'deal.error.refused.closed': 'Ez a deal már le van zárva.',
  'deal.error.refused.not_open_status': 'Ide csak nyitott státuszba lehet húzni.',
  'deal.error.refused.not_closed': 'Ez a deal még nyitott.',
  'deal.error.field': 'Ellenőrizd a mezőt: {field}.',
} as const;

export const EN: Record<keyof typeof HU, string> = {
  'nav.deals': 'Deals',
  'nav.dealsSection': 'Deals',
  'nav.dealsEmpty': 'Star a deal to keep it to hand here.',
  'nav.newDeal': 'New deal',
  'nav.allDeals': 'All deals',
  'title.deals': 'Deals',
  'title.deal': 'Deal',
  'title.settingsDeals': 'Deal management · Settings',
  'settings.nav.deals': 'Deal management',

  'deal.category.open': 'Open',
  'deal.category.won': 'Won',
  'deal.category.lost': 'Lost',
  'deal.forecast.commit': 'Commit',
  'deal.forecast.best_case': 'Best case',
  'deal.forecast.pipeline': 'Pipeline',
  'deal.forecast.omitted': 'Omitted',
  'deal.source.inbound': 'Inbound enquiry',
  'deal.source.referral': 'Referral',
  'deal.source.outbound': 'Outbound',
  'deal.source.existing': 'Existing client',
  'deal.source.tender': 'Tender',
  'deal.source.partner': 'Partner',
  'deal.seniority.junior': 'Junior',
  'deal.seniority.medior': 'Mid-level',
  'deal.seniority.senior': 'Senior',
  'deal.revenueMode.one_off': 'One-off',
  'deal.revenueMode.recurring': 'Recurring',
  'deal.revenueMode.milestones': 'By milestone',
  'deal.revenueMode.manual': 'Manual',
  'deal.lineType.fixed': 'Fixed',
  'deal.lineType.tm': 'Time and material',
  'deal.lineType.license': 'Licence',
  'deal.lineType.option': 'Option',
  'deal.lineStatus.draft': 'Draft',
  'deal.lineStatus.open': 'Open',
  'deal.lineStatus.closed': 'Closed',
  'deal.rateUnit.hour': 'hour',
  'deal.rateUnit.day': 'day',
  'deal.rateUnit.month': 'month',
  'deal.eventKind.note': 'Note',
  'deal.eventKind.task': 'Task',
  'deal.eventKind.meeting': 'Meeting',
  'deal.eventKind.call': 'Call',
  'deal.eventKind.email': 'Email',
  'deal.eventKind.system': 'System',

  'deals.mode.list': 'List',
  'deals.mode.kanban': 'Pipeline',
  'deals.mode.forecast': 'Forecast',
  'deals.mode.demand': 'Resource demand',

  'deals.view.open': 'Open',
  'deals.view.all': 'All deals',
  'deals.view.mine': 'Mine',
  'deals.view.rot': 'Rotting',
  'deals.view.nonext': 'No next step',
  'deals.view.quarter': 'Closing this quarter',
  'deals.view.slip': 'Slipped',
  'deals.view.won': 'Won',
  'deals.view.lost': 'Lost',
  'deals.view.conv': 'Converted',
  'deals.column.identifier': 'Deal',
  'deals.column.name': 'Name',
  'deals.column.client': 'Company',
  'deals.column.status': 'Status',
  'deals.column.probability': 'Probability',
  'deals.column.forecast': 'Forecast',
  'deals.column.value': 'Value',
  'deals.column.weighted': 'Weighted',
  'deals.column.hours': 'Planned hours',
  'deals.column.owner': 'Owner',
  'deals.column.close': 'Expected close',
  'deals.column.next': 'Next step',
  'deals.column.stage': 'In status',
  'deals.column.activity': 'Last activity',
  'deals.filter.status': 'Status',
  'deals.filter.owner': 'Owner',
  'deals.filter.client': 'Company',
  'deals.filter.forecast': 'Forecast category',
  'deals.search': 'Search deals and companies…',
  'deals.days': '{count} days',
  'deals.next.none': 'not set',
  'deals.next.late': 'The due date has passed.',
  'deals.rotting': 'Rotting deal: {count} days in the same status.',
  'deals.footer': '{count} deals · Σ {value} · weighted {weighted} · committed {committed}',
  'deals.action.create': 'New deal',
  'deals.action.open': 'Open',
  'deals.action.favourite': 'Add to favourites',
  'deals.action.unfavourite': 'Remove from favourites',
  'deals.action.won': 'Won',
  'deals.action.lost': 'Lost',
  'deals.action.reopen': 'Reopen',
  'deals.action.generate': 'Generate',
  'deals.action.delete': 'Delete deal',
  'deals.action.omit': 'Forecast → omitted',
  'deals.empty.title': 'No deals yet',
  'deals.empty.body':
    'A deal follows the business from the first enquiry to the contract. Start with a name and a company.',
  'deals.empty.filtered': 'No deals in this view.',
  'deals.toast.created': 'Deal created',
  'deals.toast.deleted': 'Deal deleted',
  'deals.toast.omitted': '{count} deals omitted from the forecast',
  'deals.error.value': 'Enter an amount that is not negative.',

  'deals.new.title': 'New deal',
  'deals.new.hint':
    'Name, company, owner and status are required. Everything else can be filled in later — an inbound enquiry is a valid deal.',
  'deals.new.name': 'Name',
  'deals.new.namePlaceholder': 'E.g. Rossmann — inventory module, phase 2',
  'deals.new.client': 'Company',
  'deals.new.contact': 'Contact',
  'deals.new.owner': 'Owner',
  'deals.new.status': 'Status',
  'deals.new.value': 'Indicative value',
  'deals.new.close': 'Expected close',
  'deals.new.source': 'Source',
  'deals.new.none': 'Not set',
  'deals.new.submit': 'Create deal',
  'deals.new.pickClient': 'Choose a company',
  'contacts.action.create': 'New contact',

  'resource.filter.tentative': 'Deal bookings',
  'resource.filter.tentativeHidden': 'Hidden',
  'resource.filter.tentativeShown': 'Shown',
  'resource.tentative.label': 'Tentative',
  'resource.tentative.hint':
    "An open deal's planned hours for this person. They take no capacity and never count towards utilisation.",

  'agent.tool.deals_search.running': 'Searching deals…',
  'agent.tool.deals_search.done': '{count} deals',
  'agent.tool.deals_get.running': 'Opening the deal…',
  'agent.tool.deals_get.done': 'Read the deal',
  'agent.tool.deals_pipeline.running': 'Reading the pipeline…',
  'agent.tool.deals_pipeline.done': 'Read the pipeline',
  'agent.tool.deals_forecast.running': 'Working out the forecast…',
  'agent.tool.deals_forecast.done': 'Forecast ready',
  'agent.tool.deals_demand.running': 'Working out resource demand…',
  'agent.tool.deals_demand.done': 'Resource demand ready',
  'agent.tool.deal_settings_get.running': 'Reading the deal settings…',
  'agent.tool.deal_settings_get.done': 'Read the deal settings',
  'agent.tool.deals_create.running': 'Preparing a new deal…',
  'agent.tool.deals_create.done': 'New deal waiting for approval',
  'agent.tool.deals_update.running': 'Preparing the change…',
  'agent.tool.deals_update.done': 'Change waiting for approval',
  'agent.tool.deals_set_status.running': 'Preparing the status move…',
  'agent.tool.deals_set_status.done': 'Status move waiting for approval',
  'agent.tool.deals_mark_won.running': 'Preparing to mark it won…',
  'agent.tool.deals_mark_won.done': 'Win waiting for approval',
  'agent.tool.deals_mark_lost.running': 'Preparing to mark it lost…',
  'agent.tool.deals_mark_lost.done': 'Loss waiting for approval',
  'agent.tool.deals_set_next_step.running': 'Preparing the next step…',
  'agent.tool.deals_set_next_step.done': 'Next step waiting for approval',
  'agent.tool.deals_log_activity.running': 'Preparing the activity…',
  'agent.tool.deals_log_activity.done': 'Activity waiting for approval',
  'agent.tool.deals_reopen.running': 'Preparing the reopening…',
  'agent.tool.deals_reopen.done': 'Reopening waiting for approval',
  'agent.tool.deals_complete_next_step.running': 'Preparing to complete the step…',
  'agent.tool.deals_complete_next_step.done': 'Completed step waiting for approval',
  'agent.tool.deals_update_activity.running': 'Preparing the activity edit…',
  'agent.tool.deals_update_activity.done': 'Edit waiting for approval',
  'agent.tool.deals_delete_activity.running': 'Preparing to delete the activity…',
  'agent.tool.deals_delete_activity.done': 'Deletion waiting for approval',
  'agent.tool.deals_delete.running': 'Preparing to delete the deal…',
  'agent.tool.deals_delete.done': 'Deletion waiting for approval',
  'agent.tool.deal_scenarios_search.running': 'Reading the scenarios…',
  'agent.tool.deal_scenarios_search.done': '{count} scenarios',
  'agent.tool.deal_scenarios_get.running': 'Opening the scenario…',
  'agent.tool.deal_scenarios_get.done': 'Read the scenario',
  'agent.tool.deal_scenarios_mark_winner.running': 'Preparing the winning scenario…',
  'agent.tool.deal_scenarios_mark_winner.done': 'Winning scenario waiting for approval',

  'deal.tab.overview': 'Overview',
  'deal.tab.scenario': 'Scenario',
  'deal.tab.plan': 'Plan',
  'deal.tab.resource': 'Resources',
  'deal.back': 'Back to deals',
  'deal.stage.days': '{count} d',
  'deal.copy.label': 'Copy',
  'deal.copy.identifier': 'Copy identifier',
  'deal.copy.link': 'Copy link',
  'deal.error.refused.closed': 'This deal is already closed.',
  'deal.error.refused.not_open_status': 'A deal can only be moved to an open status here.',
  'deal.error.refused.not_closed': 'This deal is still open.',
  'deal.error.field': 'Check this field: {field}.',
};
